import {START_PROFIT_WELL, LOGOUT} from "./types"

const initialState = {
    'profitWell': false
};

const trackersReducer = (state = initialState, action) => {
    switch (action.type) {
        case START_PROFIT_WELL:
            return {
                ...state,
                'profitWell': true
            }
        case LOGOUT:
            return {
                ...state,
                'profitWell': false
            };
        default:
            return state;
    }
}

export default trackersReducer;
